"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Globe = function Globe(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "globe",
    viewBox: "0 0 14 14"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-163.000000, -331.000000)",
    fill: "#000000"
  }, react_1["default"].createElement("g", {
    transform: "translate(130.000000, 296.000000)"
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("g", {
    transform: "translate(24.000000, 26.000000)"
  }, react_1["default"].createElement("g", null, react_1["default"].createElement("g", {
    transform: "translate(8.000000, 8.000000)"
  }, react_1["default"].createElement("path", {
    d: "M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,6.14348457 14.2625021,4.36300718 12.9497475,3.05025253 C11.6369928,1.73749788 9.85651543,1 8,1 Z M14,7.5 L11,7.5 C10.9416344,5.65854307 10.4645662,3.85457544 9.605,2.225 C12.0307049,2.88852715 13.7852398,4.99436827 14,7.5 L14,7.5 Z M8,14 C7.88845893,14.0074901 7.77654107,14.0074901 7.665,14 C6.62914284,12.3480936 6.05425484,10.4490642 6,8.5 L10,8.5 C9.95025706,10.4476619 9.38057898,12.3465889 8.35,14 C8.2334766,14.0081767 8.1165234,14.0081767 8,14 L8,14 Z M6,7.5 C6.04974294,5.55233806 6.61942102,3.65341113 7.65,2 C7.87263275,1.97498288 8.09736725,1.97498288 8.32,2 C9.36113811,3.65039808 9.9412369,5.54953101 10,7.5 L6,7.5 Z M6.38,2.225 C5.52564787,3.85582255 5.05372655,5.65972469 5,7.5 L2,7.5 C2.21476022,4.99436827 3.96929514,2.88852715 6.395,2.225 L6.38,2.225 Z M2.025,8.5 L5.025,8.5 C5.07717948,10.3398819 5.5473853,12.1437624 6.4,13.775 C3.98215809,13.1044136 2.23691382,11.0001476 2.025,8.5 Z M9.605,13.775 C10.4645662,12.1454246 10.9416344,10.3414569 11,8.5 L14,8.5 C13.7852398,11.0056317 12.0307049,13.1114729 9.605,13.775 Z"
  })))))))));
};

exports["default"] = Globe;